<template>
    <div>

        <v-card class="mt-4">
            <v-toolbar flat dense>
                <v-toolbar-title class="text-subtitle-1">EMAILS</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>

            <v-data-table :headers="columnsEmails" :items="correos" item-key="name" class="elevation-1"
                :custom-filter="customFilter" :loading="loading" loading-text="Cargando..." dense>
                <template v-slot:item="row">
                    <tr>
                        <td>{{ row.item.asunto }}</td>
                        <td>{{ row.item.fecha }}</td>
                        <td>{{ row.item.remitente }}</td>
                        <td style="cursor:pointer;" @click="verDetalleCorreo(row.item)">
                            <v-icon light small class="mr-2">mdi-eye</v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>



        <!-- MODAL DE CORREO -->
        <v-dialog v-model="dialogCorreo" width="600px">
            <v-card style="padding: 30px">
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Para" v-model="correoOpen.remitente" hide-details="auto"
                            readonly></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="CC" v-model="correoOpen.cc" hide-details="auto" readonly></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="BCC" v-model="correoOpen.bcc" hide-details="auto" readonly></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Asunto" v-model="correoOpen.asunto" hide-details="auto"
                            readonly></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea v-model="correoOpen.cuerpo" label="Mensaje" readonly></v-textarea>
                    </v-col>
                </v-row>

                <v-row v-if="correoOpen.documentos">
                    <v-col>
                        <p>Descargar Adjuntos</p>
                    </v-col>
                </v-row>
                <v-row v-if="correoOpen.documentos">
                    <v-col>
                        <v-chip v-for="(documento, index) in correoOpen.documentos" v-bind:key="index" color="primary"
                            outlined :href="documento.url" style="cursor: pointer">
                            <v-icon left>
                                mdi-tray-arrow-down
                            </v-icon>
                            {{ documento.nombre }}
                        </v-chip>
                    </v-col>
                </v-row>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCorreo = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- SEND EMAIL -->
        <v-dialog v-model="newCorreoDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Crear Correo</span>
                </v-card-title>
                <div style="padding:40px;">
                    <EmailForm :poliza="polizaId" :correoAgente="correoAgente" />
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="newCorreoDialog = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
import EmailForm from '../../../../components/EmailForm.vue';
export default {
    name: 'EmailsCard',
    components: {
        EmailForm
    },
    data() {
        return {
            newCorreoDialog: false,
            dialogCorreo: false,
            correoOpen: {},
            columnsEmails: [
                {
                    text: "Asunto",
                    align: "start",
                    sortable: false,
                    value: "asunto",
                },
                { text: "Fecha", value: "fecha" },
                { text: "Para", value: "remitente" },
            ],

        }
    },
    props: {
        polizaId: {
            type: Number,
            default: null
        },
        correos: {
            type: Array,
            required: true
        },
        correoAgente: {
            type: String
        },
        loading: {
            type: Boolean,
            default: false
        },
        customFilter: {
            type: Function,
            default: null
        }
    },
    methods: {
        verDetalleCorreo(correo) {
            this.dialogCorreo = true;
            this.correoOpen = correo;
        },
    }
}

</script>